import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { api } from "@/lib/api";
import { Plus } from "lucide-react";
import { useState } from "react";
import PacienteEdit from "./Paciente-edit";
import PacienteList from "./Paciente-list";
import { Paciente } from "./interface/Paciente.interface";

const Pacientes = () => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [editingPaciente, setEditingPaciente] = useState<Paciente | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (paciente: Paciente) => {
    setEditingPaciente(paciente);
    setOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (confirm("Deseja realmente excluir este paciente?")) {
      try {
        await api.delete(`/api/paciente/${id}`);
        toast({
          title: "Sucesso",
          description: "Paciente excluído com sucesso!",
        });
        // Recarrega a lista de pacientes
        setRefreshTrigger(prev => prev + 1);
      } catch (error: any) {
        console.error("Erro ao excluir paciente:", error);
        
        // Extrai a mensagem de erro do backend
        let errorMessage = "Erro ao excluir paciente";
        
        if (error.response?.data) {
          // Tenta pegar a mensagem de diferentes formatos possíveis
          errorMessage = 
            error.response.data.message || 
            error.response.data.error || 
            error.response.data.mensagem ||
            errorMessage;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        toast({
          title: "Erro",
          description: errorMessage,
          variant: "destructive",
        });
      }
    }
  };

  const handleSuccess = () => {
    // Recarrega a lista de pacientes
    setRefreshTrigger(prev => prev + 1);
    setOpen(false);
    setEditingPaciente(null);
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-foreground">Pacientes</h2>
            <p className="text-muted-foreground mt-1">Gerencie o cadastro de pacientes</p>
          </div>
          <Button
            className="gap-2"
            onClick={() => {
              setEditingPaciente(null);
              setOpen(true);
            }}
          >
            <Plus className="h-4 w-4" />
            Novo Paciente
          </Button>
        </div>

        <PacienteList
          onEdit={handleEdit}
          onDelete={handleDelete}
          refreshTrigger={refreshTrigger}
        />

        <PacienteEdit
          open={open}
          onOpenChange={setOpen}
          paciente={editingPaciente}
          onSuccess={handleSuccess}
          onUsuarioCriado={handleSuccess}
        />
      </div>
    </Layout>
  );
};

export default Pacientes;
